import { createContext, useContext, useState, useCallback } from 'react';

const AuthDialogContext = createContext(null);

export const useAuthDialog = () => {
  const ctx = useContext(AuthDialogContext);
  if (!ctx) throw new Error('useAuthDialog must be used within AuthDialogProvider');
  return ctx;
};

export const AuthDialogProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState('login');

  const openLogin = useCallback(() => {
    setMode('login');
    setOpen(true);
  }, []);

  const openRegister = useCallback(() => {
    setMode('register');
    setOpen(true);
  }, []);

  const closeDialog = useCallback(() => setOpen(false), []);

  return (
    <AuthDialogContext.Provider
      value={{ open, mode, setMode, openLogin, openRegister, closeDialog, setOpen }}
    >
      {children}
    </AuthDialogContext.Provider>
  );
};
